import React, { useState } from 'react';
import { Button, Drawer } from 'antd';

const MainDrawer = ({ drawerData, children, title, placement, extra, width }) => {

    let { open, onClose } = drawerData;

    return (
        <Drawer title={title} placement={placement} onClose={onClose} open={open} extra={extra} width={width}>
            {children}
        </Drawer>
    )
}

export default MainDrawer